// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

// libraries
import User from '../lib/User.js'

class LinksPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      categories: [],
      companies: [],
      modalOpen: false,
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  componentDidMount() {
    User.watch(this, () => {
      this.loadCategories()
      this.loadCompanies()
    })
  }

  loadCompanies = () => {
    window._api.get('/companies', (error, resp) => {
      if (error) {
        toast.error(error.message)
      }
      this.setState({ companies: resp.items })
    })
  }

  loadCategories = () => {
    window._api.get('/links/schema', (error, resp) => {
      if (error) {
        toast.error(error.message)
      }
      if (resp && resp.category) {
        this.setState({ categories: resp.category.enum })
      }
    })
  }

  render() {
    let { categories, companies, modalOpen } = this.state

    return (
      <div id="links-page">
        <Header
          title="Links"
          actions={[
            {
              children: 'Create New Link',
              onClick: this.toggleModal,
            },
          ]}
        />

        <ListView
          columns={[
            {
              key: 'name',
              link: '/links/:_id',
              sortable: true,
            },
            {
              key: 'url',
              href: ':url',
              name: 'URL',
            },
            {
              key: 'company.name',
              link: `/companies/:company._id`,
              name: 'Company',
            },
            {
              key: 'category',
              name: 'Category',
            },
          ]}
          entities="links"
          fields={['name', 'url', 'company.name', 'category']}
          filters={[
            { name: 'company', options: companies },
            { name: 'category', options: categories },
          ]}
          searchable={true}
          sort_key={'name'}
          sort_dir={1}
        />
        <Dialog open={modalOpen} close={this.toggleModal}>
          <NewEntityDialog
            close={this.toggleModal}
            entities="links"
            title="Enter a name for your new Link"
          />
        </Dialog>
      </div>
    )
  }
}

// export
export default LinksPage
